import * as React from "react";
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import TopBar from "../../../components/TopBarV2";
import Container from "@mui/material/Container/Container";
import Typography from "@mui/material/Typography/Typography";
import { useFormik, FieldArray,
  getIn, FormikProvider } from 'formik';
import JoinusValidation from "../../../validation/joinusValidation";
import Grid from "@mui/material/Grid/Grid";
import Box from "@mui/material/Box/Box";
import TextField from "@mui/material/TextField/TextField";
import Button from "@mui/material/Button/Button";
import CloseIcon from "@mui/material/SvgIcon/SvgIcon";
import AddIcon from '@mui/icons-material/Add';
import Stack from "@mui/material/Stack/Stack";
import {useNavigate, useParams } from 'react-router-dom'

function SpvProject() {
  const navigator = useNavigate();
  let { projectId } = useParams();
  const formik = useFormik({
    initialValues: JoinusValidation.initialValuesOrganizationSPV,
    validationSchema:  JoinusValidation.organizationSPVSchema,
    onSubmit: async (values) => {
      navigator('/creator/projects/add/step/1',  {state: {
          spvProject:  values
        }
      })
    },
  });
  return (
    <React.Fragment>
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
      {/* Hero unit */}
      {/*<TopBar showBar={true}/>*/}

      <Container maxWidth="fullWidth" sx={{backgroundColor: '#E3E8F0', paddingY: 3, marginY: 5 }}>
        <Container maxWidth="md" sx={{textAlign:'left' ,}}>
          <Typography variant={'h4'} color={'primary'} sx={{  marginY: 5}}>
            Set up SPV for project
          </Typography>
        </Container>
      </Container>
      <Container maxWidth="md" component="main" sx={{}}>
        <Grid container spacing={2}  sx={{pl: 0, pr: 0}}>
          <Grid item xs={12}>


            <FormikProvider value={formik}>
              <Box   component="form" onSubmit={formik.handleSubmit} sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                mb: 2,
                flexDirection:'column',
              }}
              >

                <Grid container spacing={2}>
                  <>
                    <Grid item xs={12}>
                      <TextField
                        name="spvName"
                        label='SPV Name'
                        value={formik.values.spvName}
                        onChange={formik.handleChange}
                        error={formik.touched.spvName && Boolean(formik.errors.spvName)}
                        helperText={formik.touched.spvName && formik.errors.spvName}
                        variant="outlined" sx={{width:'100%'}}/>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        name="spvCountry"
                        label='SPV Country'
                        value={formik.values.spvCountry}
                        onChange={formik.handleChange}
                        error={formik.touched.spvCountry && Boolean(formik.errors.spvCountry)}
                        helperText={formik.touched.spvCountry && formik.errors.spvCountry}
                        variant="outlined" sx={{width:'100%'}}/>
                    </Grid>
                    <Typography variant={'h6'} my={5} mx={2} mb={2}>
                      SPV Members - Add people
                    </Typography>
                    <Grid item xs={12}>
                      <FieldArray name={'peoples'} render={(arrayHelpers) => {

                        return (<>
                          {arrayHelpers?.form.values.peoples.map((p, i) => (
                            <Box key={i + 'people'} sx={{mb: 5}}>
                              {arrayHelpers?.form.values.peoples.length > 1 &&

                              <Button variant={'outlined'} color={'error'} startIcon={<CloseIcon />} onClick={() => arrayHelpers.remove(i)} sx={{float:'right'}}>
                                Remove
                              </Button>

                              }
                              <Grid container spacing={3}>

                                <Grid item xs={12} >
                                  <TextField
                                    name={`peoples.${i}.name`}
                                    label='Name'
                                    value={formik.values.peoples[i].name}
                                    onChange={formik.handleChange}
                                    error={(formik.touched && formik.touched.peoples !== undefined &&  formik.errors.peoples !== undefined) && formik.touched.peoples[i].name && Boolean(formik.errors.peoples[i].name)}
                                    helperText={(formik.touched && formik.touched.peoples !== undefined &&  formik.errors.peoples !== undefined) && formik.touched.peoples[i].name&& formik.errors.peoples[i].name}
                                    variant="outlined" sx={{width:'100%'}} />
                                </Grid>
                                <Grid item xs={12}>
                                  <TextField
                                    name={`peoples.${i}.email`}
                                    label='Email'
                                    value={formik.values.peoples[i].email}
                                    onChange={formik.handleChange}
                                    error={(formik.touched && formik.touched.peoples !== undefined
                                      &&  formik.errors.peoples !== undefined) &&
                                    formik.touched.peoples[i].email && Boolean(formik.errors.peoples[i].email)}
                                    helperText={(formik.touched && formik.touched.peoples !== undefined &&
                                      formik.errors.peoples !== undefined)
                                    && formik.touched.peoples[i].email&& formik.errors.peoples[i].email}
                                    variant="outlined" sx={{width:'100%'}} />
                                </Grid>
                                <Grid item sx={12}>
                                  {[...arrayHelpers?.form.values.peoples].pop().id === p.id &&

                                  <Button variant={'outlined'} startIcon={<AddIcon />} onClick={() => arrayHelpers.push({id: Math.random(), name:'', email:'' })}>Add another</Button>
                                  }
                                </Grid>
                              </Grid>
                            </Box>
                          ))}
                        </>)
                      }

                      }/>
                    </Grid>
                    <Typography variant={'h6'} my={5} mx={2} mb={2}>
                      SPV Members - Add Company
                    </Typography>
                    <Grid item xs={12}>
                      <FieldArray name={'companies'}  render={(arrayHelpers) => {

                        return (<>
                          {arrayHelpers?.form.values.companies.map((p, i) => (
                            <Box key={i + 'company'}  sx={{mb: 5}}>
                              {arrayHelpers?.form.values.companies.length > 1 &&

                              <Button variant={'outlined'} color={'error'} startIcon={<CloseIcon />} onClick={() => arrayHelpers.remove(i)} sx={{float:'right'}}>
                                Remove
                              </Button>

                              }
                              <Grid container spacing={3}>

                                <Grid item xs={12} >
                                  <TextField
                                    name={`companies.${i}.companyName`}
                                    label='Company name'
                                    value={formik.values.companies[i].companyName}
                                    onChange={formik.handleChange}
                                    error={(formik.touched && formik.touched.companies !== undefined &&  formik.errors.companies !== undefined) && formik.touched.companies[i].companyName && Boolean(formik.errors.companies[i].companyName)}
                                    helperText={(formik.touched && formik.touched.companies !== undefined &&  formik.errors.companies !== undefined) && formik.touched.companies[i].companyName&& formik.errors.companies[i].companyName}
                                    variant="outlined" sx={{width:'100%'}} />
                                </Grid>

                                <Grid item xs={12} >
                                  <TextField
                                    name={`companies.${i}.email`}
                                    label='Company email'
                                    value={formik.values.companies[i].email}
                                    onChange={formik.handleChange}
                                    error={(formik.touched && formik.touched.companies !== undefined &&  formik.errors.companies !== undefined) && formik.touched.companies[i].email && Boolean(formik.errors.companies[i].email)}
                                    helperText={(formik.touched && formik.touched.companies !== undefined &&  formik.errors.companies !== undefined) && formik.touched.companies[i].email && formik.errors.companies[i].email}
                                    variant="outlined" sx={{width:'100%'}} />
                                </Grid>

                                <Grid item xs={12} >
                                  <TextField
                                    name={`companies.${i}.address`}
                                    label='Company address'
                                    value={formik.values.companies[i].address}
                                    onChange={formik.handleChange}
                                    error={(formik.touched && formik.touched.companies !== undefined &&  formik.errors.companies !== undefined) && formik.touched.companies[i].address && Boolean(formik.errors.companies[i].address)}
                                    helperText={(formik.touched && formik.touched.companies !== undefined &&  formik.errors.companies !== undefined) && formik.touched.companies[i].address && formik.errors.companies[i].address}
                                    variant="outlined" sx={{width:'100%'}} />
                                </Grid>

                                <Grid item sx={12}>
                                  {[...arrayHelpers?.form.values.companies].pop().id === p.id &&

                                  <Button variant={'outlined'} startIcon={<AddIcon />} onClick={() => arrayHelpers.push({id: Math.random(), companyName:'', address:'', email:'' })}>Add another</Button>
                                  }
                                </Grid>
                              </Grid>
                            </Box>
                          ))}
                        </>)
                      }

                      }/>
                    </Grid>


                  </>
                </Grid>
                <Grid item xs={12}>
                  <Stack direction={'row'} spacing={5} justifyContent="center" mb={7}
                         alignItems="center">
                    <Button sx={{px: 5, py:1.5}} onClick={() => navigator(-1)}>
                      Go back
                    </Button>
                    <Button  variant={'contained'} sx={{px: 5, py:1.5} } type={'submit'}>
                      Next
                    </Button>

                  </Stack>
                </Grid>
              </Box>
            </FormikProvider>
          </Grid>

        </Grid>
      </Container>
    </React.Fragment>
  )
}
export default SpvProject;